import { render, staticRenderFns } from "./gift_campaign.vue?vue&type=template&id=863a9aa0&scoped=true"
import script from "./gift_campaign.vue?vue&type=script&lang=js"
export * from "./gift_campaign.vue?vue&type=script&lang=js"
import style0 from "./gift_campaign.vue?vue&type=style&index=0&id=863a9aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863a9aa0",
  null
  
)

export default component.exports